import React from 'react'
import { number, string } from 'prop-types'

const IconPlus = ({ color = "#cccccc", size = 18 }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 18 18" fill="none">
      <path d="M17.75 10.25H10.25V17.75H7.75V10.25H0.25V7.75H7.75V0.25H10.25V7.75H17.75V10.25Z" fill={color}/>
    </svg>
  )
}

IconPlus.propTypes = {
  color: string,
  size: number
}

export default IconPlus
